import { homePageReducer } from './homePageReducer';
import { settingsReducer } from './settingsReducer';
import { loadingReducer } from './loadingReducer';

const mainReducer = ({ homePage, settings, loading }, action) => ({
  homePage: homePageReducer(homePage, action),
  settings: settingsReducer(settings, action),
  loading: loadingReducer(loading, action),
});

export const initialState = {
  homePage: {
    isActive: 0, totalTime: 0, lastActive: null, notes: [],
  },
  settings: {
    interval: 0,
    isDarkMode: 0,
  },
  loading: {
    settingsLoaded: false,
    noteAdded: false,
  },
};

export default mainReducer;
